export default "__VITE_ASSET__BuzfdPx0__"